import type { CandidateVacancy } from '../types';
import { mockCandidateProfile } from './mockCandidateProfile';
import { mockCandidateRole } from './mockCandidateRole';

type CandidateUser = NonNullable<CandidateVacancy['responsibleUser']>;

export function mockCandidateUser(
  overrides: Partial<CandidateUser> = {}
): CandidateUser {
  return {
    id: 1,
    email: 'manager@example.com',
    createdAt: '2026-01-10T09:00:00.000Z',
    updatedAt: '2026-06-01T09:00:00.000Z',
    vacanciesCount: 5,
    role: mockCandidateRole(),
    profile: mockCandidateProfile(),
    company: 'Example Company',
    vacancies: ['Frontend developer'],
    ...overrides,
  };
}
